import { React, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { Doughnut } from 'react-chartjs-2';
import Lottie from 'lottie-react-web';

import FetchModule from '../../Share/Network/FetchModule';

import LoadingAnimation from '../../../Animation/LoadingAnimation.json';

const CircleGraph = (props) => {
  const { today, data, isOver, isDoughnutLoading, setIsDoughnutLoading } = props;

  const history = useHistory();

  const [topSalesName, setTopSalesName] = useState('항목 없음');
  const [topSalesPrice, setTopSalesPrice] = useState(0);
  const [totalSalesPrice, setTotalSalesPrice] = useState(0);
  const [lastMonthSales, setLastMonthSales] = useState([]);
  const [lastMonthTotalPrice, setLastMonthTotalPrice] = useState(0);
  const [priceToString, setPriceToString] = useState('');
  const [rateOfChange, setRateOfChange] = useState(0);

  const [chartData, setChartData] = useState({
    //  labels: [
    //   'Red',
    //   'Green',
    //   'Yellow'
    // ],
    datasets: [{
      label: ['', '', '', ''],
      data: [0, 0, 0, 0],
      backgroundColor: [
        '#5BD98A',
        '#FF8B48',
        '#33C8FF',
        '#ECECEC'
      ],
      hoverBackgroundColor: [
        '#5BD98A',
        '#FF8B48',
        '#33C8FF',
        '#ECECEC'
      ],
      borderColor: [
        '#5BD98A',
        '#FF8B48',
        '#33C8FF',
        '#ECECEC'
      ],
      hoverBorderColor: [
        '#5BD98A',
        '#FF8B48',
        '#33C8FF',
        '#ECECEC'
      ],
      borderWidth: 1,
    }]
  })

  useEffect(() => {

    if (data.length === 0) {
      // setChartData(newChartData);
      setTopSalesName('항목 없음');
      setTopSalesPrice(0);
      setTotalSalesPrice(0);
      return;
    }

    const newChartData = {
      datasets: [{
        label: ['', '', '', ''],
        data: [0, 0, 0, 0],
        backgroundColor: [
          '#5BD98A',
          '#FF8B48',
          '#33C8FF',
          '#ECECEC'
        ],
        hoverBackgroundColor: [
          '#5BD98A',
          '#FF8B48',
          '#33C8FF',
          '#ECECEC'
        ],
        borderColor: [
          '#5BD98A',
          '#FF8B48',
          '#33C8FF',
          '#ECECEC'
        ],
        borderWidth: 1,
      }],
    };

    var newDataList = [];

    for (var i = 0; i < data.length; i++) {
      var index = -1;

      if (newDataList.length === 0) {
        var newData = {
          itemName: data[i].itemName,
          price: data[i].cardPrice + data[i].cashPrice
        }

        newDataList.push(newData);
      }
      else {
        for (var j = 0; j < newDataList.length; j++) {
          if (newDataList[j].itemName === data[i].itemName) {
            index = j;
          }
        }

        if (index === -1) {
          newData = {
            itemName: data[i].itemName,
            price: data[i].cardPrice + data[i].cashPrice
          }

          newDataList.push(newData);
        }
        else {
          newDataList[index].price += data[i].cardPrice + data[i].cashPrice;
        }
      }
    }

    newDataList.sort(function (a, b) {
      return a.price > b.price ? -1 : a.price < b.price ? 1 : 0;
    })

    var otherData = {
      membershipName: '기타',
      price: 0
    }

    for (var k = 3; k < newDataList.length; k++) {
      otherData.price += newDataList[k].price;
    }


    setTopSalesName(newDataList[0].itemName);
    setTopSalesPrice(newDataList[0].price);

    var totalPrice = 0;

    for (var v = 0; v < newDataList.length; v++) {
      totalPrice += newDataList[v].price;
    }

    setTotalSalesPrice(totalPrice);

    if (newDataList.length === 0) {
      newChartData.datasets[0].data[0] = 0;
      newChartData.datasets[0].data[1] = 0;
      newChartData.datasets[0].data[2] = 0;
      newChartData.datasets[0].data[3] = 0;

      newChartData.datasets[0].label[0] = 0;
      newChartData.datasets[0].label[1] = 0;
      newChartData.datasets[0].label[2] = 0;
      newChartData.datasets[0].label[3] = 0;
    }
    else if (newDataList.length === 1) {
      newChartData.datasets[0].data[0] = newDataList[0].price;
      newChartData.datasets[0].data[1] = 0;
      newChartData.datasets[0].data[2] = 0;
      newChartData.datasets[0].data[3] = 0;

      newChartData.datasets[0].label[0] = newDataList[0].itemName;
      newChartData.datasets[0].label[1] = 0;
      newChartData.datasets[0].label[2] = 0;
      newChartData.datasets[0].label[3] = 0;
    }
    else if (newDataList.length === 2) {
      newChartData.datasets[0].data[0] = newDataList[0].price;
      newChartData.datasets[0].data[1] = newDataList[1].price;
      newChartData.datasets[0].data[2] = 0;
      newChartData.datasets[0].data[3] = 0;

      newChartData.datasets[0].label[0] = newDataList[0].itemName;
      newChartData.datasets[0].label[1] = newDataList[1].itemName;
      newChartData.datasets[0].label[2] = 0;
      newChartData.datasets[0].label[3] = 0;
    }
    else if (newDataList.length === 3) {
      newChartData.datasets[0].data[0] = newDataList[0].price;
      newChartData.datasets[0].data[1] = newDataList[1].price;
      newChartData.datasets[0].data[2] = newDataList[2].price;
      newChartData.datasets[0].data[3] = 0;

      newChartData.datasets[0].label[0] = newDataList[0].itemName;
      newChartData.datasets[0].label[1] = newDataList[1].itemName;
      newChartData.datasets[0].label[2] = newDataList[2].itemName;
      newChartData.datasets[0].label[3] = 0;
    }
    else if (newDataList.length >= 4) {
      newChartData.datasets[0].data[0] = newDataList[0].price;
      newChartData.datasets[0].data[1] = newDataList[1].price;
      newChartData.datasets[0].data[2] = newDataList[2].price;
      newChartData.datasets[0].data[3] = otherData.price;

      newChartData.datasets[0].label[0] = newDataList[0].itemName;
      newChartData.datasets[0].label[1] = newDataList[1].itemName;
      newChartData.datasets[0].label[2] = newDataList[2].itemName;
      newChartData.datasets[0].label[3] = otherData.membershipName;
    }

    setChartData(newChartData);
  }, [data]);

  useEffect(() => {
    setTimeout(() => (
      setIsDoughnutLoading(false)
    ), 1300)
  }, [chartData])

  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getIndividualData('sales/' + today.clone().subtract(1, 'month').format('YYYY-MM') + '-01T00:00:00', 'GET');

        if (responseData.status === 200) setLastMonthSales(responseData.data);
        else if (responseData.status === 401) history.push('/');
        else if (responseData.status === 204) setLastMonthSales([]);
      }
    )();
  }, [today, history])

  useEffect(() => {
    if (lastMonthSales.length === 0) setLastMonthTotalPrice(0);
    else {
      var totalPrice = 0;

      for (var i = 0; i < lastMonthSales.length; i++) {
        totalPrice += lastMonthSales[i].cashPrice + lastMonthSales[i].cardPrice;
      }

      setLastMonthTotalPrice(totalPrice);
    }
  }, [lastMonthSales])

  useEffect(() => {
    var hanA = ["", "일", "이", "삼", "사", "오", "육", "칠", "팔", "구", "십"];
    var danA = ["", "십", "백", "천", "", "십", "백", "천", "", "십", "백", "천", "", "십", "백", "천"];
    var stringPrice = totalSalesPrice.toString();
    var result = "";

    for (var i = 0; i < stringPrice.length; i++) {
      var str = "";
      var han = hanA[stringPrice.charAt(stringPrice.length - (i + 1))];

      if (han !== "") str += han + danA[i];
      if (i === 4) str += "만";
      if (i === 8) str += "억";
      if (i === 12) str += "조";

      result = str + result;
    }

    if (stringPrice !== 0) result = result + "원";

    setPriceToString(result);
  }, [totalSalesPrice])

  useEffect(() => {
    // 금월 매출이 0원일 경우
    if (totalSalesPrice === 0) setRateOfChange(0);
    // 전월 매출이 0원인 경우
    else if (lastMonthTotalPrice === 0) setRateOfChange(100);
    // 전월 금월 매출이 존재할경우
    else setRateOfChange(Math.round((totalSalesPrice - lastMonthTotalPrice) / lastMonthTotalPrice * 100));
  }, [totalSalesPrice, lastMonthTotalPrice])

  return (
    <TopLevelWrapper isOver={isOver}>
      <InfoBox>
        <TitleWrapper isOver={isOver}>
          <Title isOver={isOver}>{today.clone().format('YYYY년 MM월 총 매출')}</Title>
        </TitleWrapper>
        {
          isDoughnutLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie options={{ animationData: LoadingAnimation }} />
              </LottieWrapper>
            </AnimationBox>
            :
            <InfoView>
              <ChartWrapper isOver={isOver}>
                <TotalPriceViewWrapper isOver={isOver}>
                  <TotalPriceView isOver={isOver}>{totalSalesPrice.toLocaleString('ko-KR')}원</TotalPriceView>
                  <TotalPriceText>{priceToString}</TotalPriceText>
                </TotalPriceViewWrapper>
                <DoughnutChartWrapper isOver={isOver}>
                  <Doughnut data={chartData} />
                </DoughnutChartWrapper>
              </ChartWrapper>
              <SubInfoBox isOver={isOver}>
                <TextWrapper>
                  <InfoText>{topSalesName}</InfoText>
                  <Explanation>({totalSalesPrice === 0 || topSalesPrice === 0 ? 0 : Math.ceil((topSalesPrice / totalSalesPrice) * 100)}%)</Explanation>
                </TextWrapper>
                <TextWrapper>
                  <InfoText>{totalSalesPrice.toLocaleString('ko-KR')}원</InfoText>
                  <Explanation>(전월 대비 {rateOfChange > 0 ? rateOfChange + `% 상승` : rateOfChange * -1 + `% 감소`})</Explanation>
                </TextWrapper>
              </SubInfoBox>
            </InfoView>
        }
      </InfoBox>
    </TopLevelWrapper>
  )
}

export default CircleGraph;

const TopLevelWrapper = styled.div`
  display: flex;
  felx-direction: column;

  justify-content: center;
  align-items: center;

  width: ${props => props.isOver ? `max(692px, 90.10416666666667vw)` : `max(300px, 93.75vw)`};
  height: ${props => props.isOver ? `574px` : `430px`};

  border-radius: 30px;
  box-shadow: 0px 40px 50px rgba(240, 232, 227,0.5);
  background-color: #FFFFFF;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-conetent: center;
  align-items: center;
  
  width: 91.9%;
  height: 82.57%;
`;

const InfoView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.isOver ? `max(636px, 82.8125vw)` : `max(262px, 81.875vw)`};
`;

const Title = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: ${props => props.isOver ? `14px` : `10px`};

  color: #232323;

  margin: 0 0 0 0;
`;

const ChartWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: ${props => props.isOver ? `max(636px, 82.8125vw)` : `max(262px, 81.875vw)`};
  height: ${props => props.isOver ? `400px` : `300px`};

  margin-top: 24px;
  border-top: 1px solid #DFDFDF;
`;

const DoughnutChartWrapper = styled.div`
  position: relative; 
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: ${props => props.isOver ? `352px` : `262px`};
  height: ${props => props.isOver ? `352px` : `262px`};
`;

const TotalPriceViewWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 4px;

  // width: ${props => props.isOver ? `214px` : `160px`};
  // height: ${props => props.isOver ? `214px` : `160px`};

  margin-top: 10px;
  // margin-top: 74px;


  border-radius: ${props => props.isOver ? `214px` : `160px`};
  background-color: #FFFFFF;
`;

const AnimationBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  z-index: 5;
  
  width: 100%;
  height: 100%;

  // background-color: rgba(0, 0, 0, 0.2);
  background-color: #FFFFFF;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 80px;
  height: 80px;
`;

const TotalPriceView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: ${props => props.isOver ? `158px` : `117px`};
  height: ${props => props.isOver ? `40px` : `30px`};

  width: ${props => props.isOver ? `130px` : `89px`};
  height: ${props => props.isOver ? `40px` : `30px`};

  border-radius: 15px;
  background-color: #ECECEC;

  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: #777777;
`;

const TotalPriceText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #777777;

  margin: 0 0 0 0;
`;

const SubInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: ${props => props.isOver ? `350px` : `260px`};
  height: ${props => props.isOver ? `64px` : `50px`};

  gap: 8px;

  border: 1px solid #E3E3E3;
  border-radius: 12px;
  background-color: #FFFFFF;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-left: 12px;
`;

const InfoText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: #000000;

  margin: 0 0 0 0;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #777777;

  margin: 0 0 0 3px;
`;